// extracted by mini-css-extract-plugin
export default {"root":"CloseableDialog-module__root___3Xmao","icon":"CloseableDialog-module__icon___1f_dT"};